module.exports = __webpack_public_path__ + "img/linked-account.7691f6b4.png";